import React, { useEffect } from 'react';
import useAgencyDetail from '../use-agency-detail';
import AuditStatus from './components/audit-status';
import AgencyInfo from './components/agency-info';
import ContactInfo from './components/contact-info';
import { Loading } from '@tencent/ptp-fe-common';
import { report } from 'store/report';

const BasicInfo: React.FC = () => {
  const agencyDetailProps = useAgencyDetail();

  useEffect(() => {
    report({ event: 'agency_manage', payload: '入驻管理' });
  }, []);

  return (
    <div className="basic-info">
      <AuditStatus data={agencyDetailProps.data} />
      <AgencyInfo {...agencyDetailProps} />
      <ContactInfo {...agencyDetailProps} />
      {agencyDetailProps.loading && <Loading />}
    </div>
  );
};

export default BasicInfo;
